import script from "./FilterController.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterController.vue?vue&type=script&setup=true&lang=js"

import "./FilterController.vue?vue&type=style&index=0&id=336fd9f3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336fd9f3"]])

export default __exports__